import axios from 'axios';

export const initialState = {
	init: false,
	accountHolder: null,
	iban: null,
	last4: null,
	source: null,
	cancellationDate: null,
	invoices: [],
};

export const mutations = {
  UPDATE_SUBSCRIPTION(state, subscription) {
    Object.assign(state, subscription);
  },
  
  SET_INVOICES(state, invoices) {
    state.invoices = invoices;
  },
  RESET(state) {
    Object.keys(state).forEach((attr) => { state[attr] = initialState[attr]; });
  },
};

export const actions = {
  async addSource({ state }, source) {
    source = source || state.source;
    await axios.post('/subscription', { source });
  },
  
  async updateSource({ state }, source) {
    source = source || state.source;
    await axios.put('/subscription', { source });
  },
  
  async getSource({ commit }) {
    const { data } = await axios.get('/subscription');
    commit('UPDATE_SUBSCRIPTION', {
      accountHolder: data.sepa.owner,
      last4: data.sepa.last4,
      cancellationDate: data.cancellationDate,
    });
  },
  
  async getInvoices({ commit }) {
    try {
      const { data } = await axios.get('/subscription/invoices');
      commit('SET_INVOICES', data);
    } catch (error) {
      if (!error.handled && error.response.status !== 404) {
        console.error(error);
      }
    }
  },
  
  async remove({ commit }) {
    const { data } = await axios.delete('/subscription');
    commit('UPDATE_SUBSCRIPTION', {
      cancellationDate: data.cancellationDate,
    });
  }

};


export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
